(() => {
'use strict';
function $fc26d12f97f936c4$var$onLoadPage() {
    // detectFIDOUsers();
    $fc26d12f97f936c4$var$showError();
}
function $fc26d12f97f936c4$var$showError() {
    if (document.getElementById('errId').getAttribute('data-error') !== '' && document.getElementById('errId').getAttribute('data-error') !== '@ERROR_MESSAGE@') document.getElementById('error-box').classList.remove('d-none');
}
window.addEventListener('load', $fc26d12f97f936c4$var$onLoadPage);

})();
//# sourceMappingURL=login.js.map
